import { LoginLog } from "../../../../domain/login_log/LoginLog";
import { useSelector } from "react-redux";
import { State } from "../../../../state/store";
import { UserId } from "../../../../domain/user/UserId";
import { UserName } from "../../../../domain/user/UserName";
import { UserEmail } from "../../../../domain/user/UserEmail";
import { getUserAccountRoleFromValue } from "../../../../domain/user/account/UserAccountRole";
import { DateTime } from "../../../../domain/fundamental/DateTime";
import { CareRecipientHouseId } from "../../../../domain/care_recipient/CareRecipientHouseId";

export const useFilteredLoginLogList = (): LoginLogListType => {
    const loginLogJsonList = useSelector((state: State) => state.adminLoginLogList.filteredLoginLogList);

    const list = loginLogJsonList.list?.map(json => {
        return LoginLog.from(
            UserId.fromString(json.userName),
            UserName.fromString(json.userName),
            UserEmail.fromString(json.email),
            getUserAccountRoleFromValue(json.role),
            DateTime.fromString(json.time),
            json.houseIdList.map(houseIdJson => CareRecipientHouseId.fromString(houseIdJson))
        );
    }) ?? [];

    const { roleConditions, houseIdPrefixConditions } = loginLogJsonList;

    return { loginLogList: list, roleConditions: roleConditions, houseIdPrefixConditions: houseIdPrefixConditions };
};

type LoginLogListType = {
    loginLogList: LoginLog[],
    roleConditions: string[],
    houseIdPrefixConditions: string[]
}
